module.exports = __webpack_public_path__ + "static/media/orange-cluster.32222ea2.svg";